import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { toast } from 'material-react-toastify';
import { sharedColors, sharedStyles } from '../../../utils/Style';
import { getOrderMessage } from '../../../api/Order';

type OrderMessageDialogProps = {
  orderID: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  open: boolean;
  onClose: () => void;
};

export const OrderMessageDialog = ({
  orderID,
  firstName,
  lastName,
  phoneNumber,
  open,
  onClose,
}: OrderMessageDialogProps) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setMessage('');
  }, [open, orderID, phoneNumber]);

  const generateMessage = () => {
    setLoading(true);
    getOrderMessage(orderID)
      .then(setMessage)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const handleSend = () => {
    const phone = `9${phoneNumber.replace(/\D/g, '')}`;
    const safeMessage = message.normalize('NFC');
    const encoded = encodeURIComponent(safeMessage);
    const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encoded}`;
    window.open(url, '_blank');
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ ...sharedStyles.h6, color: sharedColors.gray6 }}>
        WhatsApp Mesajı Gönder
      </DialogTitle>

      <DialogContent
        sx={{ width: 500, display: 'flex', flexDirection: 'column', gap: 1.5 }}
      >
        <Typography sx={{ fontWeight: 600 }}>Müşteri</Typography>
        <TextField
          fullWidth
          value={`${firstName} ${lastName}`}
          disabled
          size='small'
        />

        <Typography sx={{ fontWeight: 600 }}>Telefon Numarası</Typography>
        <TextField fullWidth value={`${phoneNumber}`} disabled size='small' />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>Mesaj</Typography>

          {loading && <CircularProgress size={24} color='primary' />}

          <IconButton
            color='primary'
            onClick={generateMessage}
            sx={{ ml: 'auto' }}
          >
            <AutoAwesomeIcon />
          </IconButton>
        </Box>
        <TextField
          disabled={loading}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          multiline
          minRows={4}
          label='Mesaj'
          size='small'
        />
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={onClose}
          sx={sharedStyles.buttonText}
        >
          Kapat
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={!message || loading}
          onClick={handleSend}
          sx={sharedStyles.buttonText}
        >
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
};
